const Footer = () => {
    return(
        <footer>
            <h3 class="text-center">~ 2025 - Daniel Feller ~</h3>
        </footer>
    )
}

export default Footer;